export type CloudSignUpRequest = {
  readonly payload: FormPayloadType | FormPayloadActivateProducts;
  readonly cookies: CloudSignUpRequestCookies;
};

export type MarketplaceAppInstallRequest = {
  readonly siteName: string;
  readonly appKey: string;
  readonly xsrfToken: string;
};

export type MarketplaceAppInstallResponse = {
  readonly status: {
    readonly statusCode: number;
  };
  readonly links: {
    readonly self: string;
  };
};

export type FreeBreachRequest = {
  readonly payload: {
    readonly cloudId: string;
    readonly productKeys: string[];
  };
};
export type FreeBreachResponse = {
  readonly isInBreachOfFree: boolean;
};

export type ProductEditionByCloudIdRequest = {
  readonly cloudId: string;
  readonly productKey: string;
};
export type ProductEditionByCloudIdResponse = {
  readonly edition: string;
};

export type CloudSignUpResponse = {
  readonly cloudId: string;
  readonly progressUri: string;
  readonly cloudName?: string;
};

export type CloudSignUpRequestCookies = {
  readonly _ga: string;
  readonly seg_xid: string;
  readonly __atl_path: string;
  readonly ajs_anonymous_id: string;
};

export type FormPayloadType = {
  readonly adminUsername: string;
  readonly gRecaptchaResponse?: string;
  readonly cloudName: string | null;
  readonly email: string | null;
  readonly timezone: string | null;
  readonly firstName: string | null;
  readonly lastName: string | null;
  readonly adminPassword: string | null;
  readonly signupContext?: string;
  readonly dataRegion?: string;
  readonly consent: {
    readonly site: string | null;
    readonly locale: string | null;
    readonly formUrl: string | null;
    readonly consents: ConsentsObject[];
  };
} & FormPayloadActivateProducts;

export type FormPayloadActivateProducts = {
  readonly activateProducts?: boolean;
  readonly products: ProductPayloadObject[];
  readonly cloudId?: string;
  readonly cloudName: string | null;
  readonly advancedSettings?: {
    readonly additionalProvisioningData: {
      readonly workspaceUuid?: string;
    };
  };
  readonly signupContext?: string;
};

export type ProductPayloadObject = {
  readonly accountName?: string | null;
  readonly edition?: string | null;
  readonly product?: string | null;
  readonly productKey?: string | null;
};

export type ConsentsObject = {
  readonly key: string;
  readonly displayedText: unknown;
  readonly granted: boolean;
};

export type CloudExpandFreeValidationRequest = {
  readonly cloudId: string;
  readonly productKeys: readonly string[];
  readonly edition?: string;
};

export type CloudExpandFreeValidationResponse = {
  readonly isInBreachOfFree: boolean;
};
